import { render, staticRenderFns } from "./BodyMessageThree.vue?vue&type=template&id=2d5216a4&scoped=true&"
import script from "./BodyMessageThree.vue?vue&type=script&lang=js&"
export * from "./BodyMessageThree.vue?vue&type=script&lang=js&"
import style0 from "./BodyMessageThree.vue?vue&type=style&index=0&id=2d5216a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5216a4",
  null
  
)

export default component.exports